import React, {useEffect} from 'react';
import {
  Title,
  Typography,
  Link,
  Icon
} from '@npm-registry/eapteka-ui';

import 'src/services/telemetry/trackers/bannerRecipeInfo.js';
import { bannerRecipeDispatchers } from 'src/components/bannerRecipe/dispatchers';

import './Info.scss';

const Banner = ({
  onOpenInfoModal,
  onClick
}) => {
  useEffect(() => {
    bannerRecipeDispatchers.onRecipeDeliveryConfirmationViewed.dispatch();
  }, []);

  const handleOnboardingClick = () => {
    bannerRecipeDispatchers.onRecipeOnboardingClicked.dispatch();
    onOpenInfoModal();
  };

  const handleApplyDeliveryClick = () => {
    bannerRecipeDispatchers.onRecipeDeliveryConfirmationClicked.dispatch();
    onClick();
  };

  const handleAgreementClick = () => {
    bannerRecipeDispatchers.onRecipeAgreementClicked.dispatch();
  };

  return (
    <div className='BannerRecipeInfo_Root'>
      <Title className='BannerRecipeInfo_Title' tag='h4'>Хотите получать рецептурные товары на дом?</Title>
      <span className='BannerRecipeInfo_Icon' onClick={handleOnboardingClick}>
        <Icon name='exclamation' />
      </span>
      <Typography variant='p3' className='BannerRecipeInfo_Text'>
        <span>Для этого разрешите нам просматривать ваши электронные рецепты и примите новое </span>
        <Link onClick={handleAgreementClick} href='/company/contract/'>пользовательское соглашение</Link>
      </Typography>
      <button className='BannerRecipeInfo_Button' type='button' onClick={handleApplyDeliveryClick}>Хочу доставку, разрешаю</button>
    </div>
  );
};

export default Banner;
